import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes } from '../../../components/foundations/Icon';
import CodeBlock from '../../../components/organisms/CodeBlock/CodeBlock';
import css from './CodeArtifact.css';

const CodeArtifact = ({ artifact }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);

    const codeContent = artifact.data;
    const language = 'python';
    const codeString =
        typeof codeContent === 'string' ? codeContent : codeContent?.code || JSON.stringify(codeContent, null, 2);

    const toggleCollapse = () => setIsCollapsed(!isCollapsed);

    return (
        <div className={css.codeArtifact}>
            <div className={css.header} onClick={toggleCollapse}>
                <Icon
                    name={isCollapsed ? 'chevron-right' : 'chevron-down'}
                    size={IconSizes.SMALL}
                    className={css.collapseIcon}
                />
                <Icon name="code" size={IconSizes.SMALL} />
                <span>Generated Code</span>
            </div>
            {!isCollapsed && (
                <CodeBlock
                    initialCode={codeString || 'No code content available'}
                    codeLanguage={language}
                    showHeader
                    showLineNumbers
                    darkTheme
                    codeClassName={css.codeBlock}
                />
            )}
        </div>
    );
};

CodeArtifact.propTypes = {
    artifact: PropTypes.shape({
        data: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
                type: PropTypes.string,
                code: PropTypes.string,
            }),
        ]),
    }).isRequired,
    isLast: PropTypes.bool,
};

export default CodeArtifact;
